const end = new Date()
const start = new Date()
start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
const range = [
    start,
    end,
]

const state = {
    range,
}

const getters = {
    range: (state) => state.range,
}

const mutations = {
    SET_RANGE: (state, range) => (state.range = range),
}

const actions = {
    setRange: ({ commit }, range) => commit('SET_RANGE', range),
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
